import { graphql } from "gatsby"
import React, { useContext } from "react"

import { SiteContext } from "@context/Provider"
import VideoAdvancedOrganism from "@knowit-alma/common/src/components/organisms/VideoAdvanced/VideoAdvanced"

const VideoAdvanced = ({ blockDataVideoAdvanced }) => {
  const {
    variant,
    heading,
    embed,
    jwplayer,
    autoplay,
    posterImage,
    caption,
    background,
  } = blockDataVideoAdvanced || {}

  const context = useContext(SiteContext)

  return (
    <VideoAdvancedOrganism
      variant={variant}
      heading={heading}
      embed={embed}
      posterImage={posterImage}
      caption={caption}
      background={background}
      autoplayWhenVisible={variant !== "jwplayer" && autoplay}
      jwplayer={variant === "jwplayer" ? jwplayer : false}
      jwPlayerIDs={variant === "jwplayer" ? context.jwPlayerIDs : false}
    />
  )
}

export const query = graphql`
  fragment VideoAdvanced on WpBlockAcfVideoAdvanced {
    __typename
    blockDataVideoAdvanced {
      variant
      heading
      embed
      jwplayer
      autoplay
      posterImage {
        mediaDetails {
          width
          height
        }
        sourceUrl
        altText
        altTextOriginal
      }
      caption
      background
    }
  }
`

export default VideoAdvanced
